import * as THREE from "three";
import { RoundedBoxGeometry } from "three/examples/jsm/geometries/RoundedBoxGeometry.js";
import { inked, toon } from "../toon";
import type { SkaterLook } from "./look";
import { facets } from "./geom";

// The skateboard: deck, trucks and wheels.

export function buildBoard(look: SkaterLook): THREE.Group {
  const board = new THREE.Group();
  const deckMat = toon(look.deck, { roughness: 0.45 }, "paint");
  const deck = inked(new RoundedBoxGeometry(0.24, 0.035, 0.62, facets(2, 1), 0.015), deckMat, 0.012);
  board.add(deck);
  for (const end of [1, -1]) {
    const kick = inked(new RoundedBoxGeometry(0.24, 0.035, 0.16, facets(2, 1), 0.015), deckMat, 0.012);
    kick.position.set(0, 0.03, end * 0.37);
    kick.rotation.x = -end * 0.38;
    board.add(kick);
  }
  const grip = new THREE.Mesh(new THREE.BoxGeometry(0.22, 0.004, 0.6), toon("#222230", { roughness: 0.95 }));
  grip.position.y = 0.019;
  board.add(grip);
  const truckMat = toon("#b9c0cc", { roughness: 0.3, metalness: 0.7 }, "metal");
  const wheelMat = toon(look.wheels, { roughness: 0.35 });
  const wheelGeo = new THREE.CylinderGeometry(0.035, 0.035, 0.04, facets(14));
  wheelGeo.rotateZ(Math.PI / 2);
  for (const end of [1, -1]) {
    const truck = inked(new THREE.BoxGeometry(0.2, 0.03, 0.05), truckMat, 0.01);
    truck.position.set(0, -0.04, end * 0.2);
    board.add(truck);
    for (const side of [1, -1]) {
      const wheel = inked(wheelGeo, wheelMat, 0.01);
      wheel.position.set(side * 0.11, -0.065, end * 0.2);
      board.add(wheel);
    }
  }
  return board;
}
